<template>
  <div>
    <el-row>
      <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
        <el-tooltip
          class="item"
          effect="dark"
          content="返回上一级页面"
          placement="bottom-start"
          :disabled="showTooltip"
        >
          <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
        </el-tooltip>
      </el-col>
      <el-col :span="12">
        <h3>
          <span v-show="!create">修改定时任务信息</span>
          <span v-show="create">新增定时任务信息</span>
        </h3>
      </el-col>
    </el-row>
    <div style="max-width: 800px">
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="180px"
        v-loading="showLoading"
      >
        <el-row>
          <el-form-item label="定时任务名称" prop="dsrwMc">
            <el-input
              ref="ipt01"
              v-model="form.dsrwMc"
              placeholder="请输入"
              maxlength="100"
              show-word-limit
              :disabled="!create"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="定时任务表达式" prop="dssjBds">
              <el-input
                ref="ipt02"
                v-model="form.dssjBds"
                placeholder="请输入"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="任务执行类" prop="rwzxl">
              <el-input
                ref="ipt03"
                v-model="form.rwzxl"
                placeholder="请输入"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="任务执行方法" prop="rwzxff">
              <el-input
                ref="ipt04"
                v-model="form.rwzxff"
                placeholder="请输入"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col><el-col :span="12">
            <el-form-item label="所属应用" prop="ssyy">
              <el-input
                ref="ipt04"
                v-model="form.ssyy"
                placeholder="请输入"
                maxlength="100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>        
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否允许并发" prop="bfzxzt">
              <el-select v-model="form.bfzxzt">
                <el-option label="是 " value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启停状态" prop="qtzt">
              <el-select v-model="form.qtzt">
                <el-option label="启动 " value="1"></el-option>
                <el-option label="停止" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="启用状态" prop="yxbz">
              <el-select v-model="form.yxbz">
                <el-option label="启用 " value="Y"></el-option>
                <el-option label="禁用" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="序号" prop="xh">
              <el-input
                ref="ipt04"
                v-model.number="form.xh"
                placeholder="请输入"
                maxlength="11"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="备注" prop="bz">
              <el-input
              type="textarea"
                ref="ipt04"
                v-model="form.bz"
                placeholder="请输入"
                maxlength="100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

let _kits, _form;
export default {
  props: ["entity"],
  data() {
    var checkRwzxl = (rule, value, callback) => {
      const reg = /^[0-9A-Za-z.]*$/;
      if (!reg.test(value)) {
        callback(new Error("任务执行类只能是数字和字母组成"));
      } else {
        callback();
      }
    };
    var checkRwzxff = (rule, value, callback) => {
      const reg = /^[0-9A-Za-z]*$/;
      if (!reg.test(value)) {
        callback(new Error("任务执行方法只能是数字和字母组成"));
      } else {
        callback();
      }
    };

    let create = this.entity.create;
    let form;
    console.log("create", create);
      form = {
        dsrwLsh: this.entity.dsrwLsh||"",
        dsrwMc: "",
        dssjBds: "",
        rwzxl: "",
        rwzxff: "",
        qtzt: "1",
        bfzxzt: "0",
        ssyy: "",
        bz: "",
        yxbz: "Y",
        xh: ""
      };
    let data = {
      showLoading: true,
      showTooltip: false,
      showBtnLoading: false,
      create,
      einvtypeCodeOptions: [],
      form,
      formRules: {
        dsrwMc: [
          {
            required: true,
            message: "请输入定时任务名称",
            trigger: "blur"
          },
          {
            max: 100,
            message: "最多100个字符",
            trigger: "blur"
          }
        ],
        dssjBds: [
          {
            required: true,
            message: "请输入定时时间表达式",
            trigger: "blur"
          },
          {
            max: 200,
            message: "最多200个字符",
            trigger: "blur"
          }
        ],
        rwzxl: [
          {
            required: true,
            message: "请输入任务执行类",
            trigger: "blur"
          },
          {
            validator: checkRwzxl,
            trigger: "blur"
          },
          {
            max: 200,
            message: "最多200个字符",
            trigger: "blur"
          }
        ],
        rwzxff: [
          {
            required: true,
            message: "请输入任务执行方法",
            trigger: "blur"
          },
          {
            validator: checkRwzxff,
            trigger: "blur"
          },
          {
            max: 200,
            message: "最多200个字符",
            trigger: "blur"
          }
        ],
        bfzxzt: [
          {
            required: true,
            message: "请选择是否允许并发",
            trigger: "blur"
          }
        ],
        qtzt: [
          {
            required: true,
            message: "请选择启停状态",
            trigger: "blur"
          }
        ],
        ssyy: [
          {
            required: true,
            message: "请输入所属应用",
            trigger: "blur"
          },
          {
            max: 100,
            message: "最多100个字符",
            trigger: "blur"
          }
        ],
        bz: [
          {
            max: 200,
            message: "最多200个字符",
            trigger: "blur"
          }
        ],
        xh: [
          {
            type: "number",
            message: "序号必须为数字值"
          }
        ]
      }
    };
    console.log("data is ", data);
    return data;
  },
  methods: {
    onBack() {
      this.$emit("back");
    },
    onSave() {
      _form.submit();
    }
  },
  created() {
    _kits = this.$kits();
    console.log("this.create",this.create);
    if (!this.create) {
    this.showLoading = true;
      var dsrwLsh = this.entity.dsrwLsh;
      _kits.api.call(
        "GETDSRWXXBYID",
        {
          dsrwLsh: dsrwLsh
        },
        result => {
          if (result.returnCode == "0000") {
            this.form = result.data;
          } else {
            this.$message.error(result.returnMsg);
          }
        this.showLoading = false;
        }
      );
    }
  },
  mounted() {
    _form = _kits.control.getStandardForm({
      name: "form",
      api: this.create ? "SAVEDSRWPZ" : "UPDATEDSRWXX"
    });
    this.showLoading = false;
  }
};
</script>